import React, { useEffect, useRef, useState } from "react";
import useAIConfigs from "@/hooks/useAIConfigs";
import useApi from "@/hooks/useApi";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "@/components/ds";
import { AIConfiguration } from "../types";

export default function AINewCreateChatbotButton() {
  const { aiConfigurations, add, update } = useAIConfigs();
  const api = useApi();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);
  const pendingConfigRef = useRef<AIConfiguration | null>(null);

  useEffect(() => {
    const saveNewChatbot = async () => {
      const pendingConfig = pendingConfigRef.current;
      if (!creating || !pendingConfig || pendingConfig.id !== 0) {
        return;
      }

      try {
        const response = await api.messaging.post(
          "AIConfiguration",
          pendingConfig
        );
        if (response.ok) {
          const savedConfig = await response.json();
          // Find the index of the pending config by reference
          const index = aiConfigurations.indexOf(pendingConfig);
          if (index !== -1) {
            update(savedConfig, index);
          }
          navigate(`/ai-new/settings/general/${savedConfig.id}`);
        }
      } catch (err) {
        console.error("Failed to create chatbot", err);
      } finally {
        pendingConfigRef.current = null;
        setCreating(false);
      }
    };
    saveNewChatbot();
  }, [creating, aiConfigurations, api.messaging, navigate, update]);

  const handleCreate = () => {
    const newConfig = add();
    pendingConfigRef.current = newConfig;
    setCreating(true);
  };

  return (
    <PrimaryButton onClick={handleCreate} disabled={creating}>
      <span className="text-base leading-none mr-1">+</span>
      {creating ? "Creating…" : "New Chatbot"}
    </PrimaryButton>
  );
}
